import React from "react";
import { Link } from "react-router-dom";

import { Button } from "../../../shared/Button/Button";

import roomPanelImage from "../../../../assets/images/Goget One (2nd).webp";
import sensorImage from "../../../../assets/images/workspace occupancy sensor.webp";
import totalCareImage from "../../../../assets/images/total-care-support.webp";

import "./BillingAddProducts.scss";

type BillingAddProductTone = "teal" | "blue" | "mint";

interface BillingAddProduct {
  id: string;
  eyebrow: string;
  tone: BillingAddProductTone;
  title: string;
  description: string;
  image: string;
  imageAlt: string;
}

export const BILLING_ADD_PRODUCTS_STORE_PATH = "/product-store";

export const BILLING_ADD_PRODUCTS: BillingAddProduct[] = [
  {
    id: "room-panel",
    eyebrow: "Room panel",
    tone: "teal",
    title: "GOGET One (2nd Gen)",
    description:
      "10” Soft Touch White room panel with LED, PoE, WiFi & Android 14.",
    image: roomPanelImage,
    imageAlt: "GOGET One second generation room panel",
  },
  {
    id: "sensor",
    eyebrow: "Sensor",
    tone: "blue",
    title: "Occupancy sensor",
    description: "Workspace occupancy sensor including service activation.",
    image: sensorImage,
    imageAlt: "GOGET workspace occupancy sensor",
  },
  {
    id: "total-care",
    eyebrow: "Services",
    tone: "mint",
    title: "Total Care Support",
    description:
      "Hands-on technical assistance for Microsoft 365, Google Workspace and more",
    image: totalCareImage,
    imageAlt: "Total Care Support technical assistance illustration",
  },
];

export const BillingAddProducts = () => {
  return (
    <section
      className="BillingAddProducts Subscriptions__card default-box"
      aria-labelledby="billing-add-products-title"
    >
      <div className="BillingAddProducts__header main-flex gap-1">
        <div>
          <h2
            id="billing-add-products-title"
            className="Subscriptions__cardTitle"
          >
            Add products & Add-ons
          </h2>
          <p>
            Equip more spaces or add specialist services. Products ship directly
            to most countries.
          </p>
        </div>
        <Button
          tag={Link}
          to={BILLING_ADD_PRODUCTS_STORE_PATH}
          title="View product store"
          className="Subscriptions__button Subscriptions__button--dark"
        />
      </div>

      <ul className="BillingAddProducts__list">
        {BILLING_ADD_PRODUCTS.map((product) => (
          <li
            key={product.id}
            className="BillingAddProducts__item Subscriptions__panel"
            data-testid="billing-add-product"
          >
            <div
              className={`BillingAddProducts__media BillingAddProducts__media--${product.id}`}
            >
              <img src={product.image} alt={product.imageAlt} />
            </div>
            <div className="BillingAddProducts__body">
              <span
                className={`BillingAddProducts__eyebrow BillingAddProducts__eyebrow--${product.tone}`}
              >
                {product.eyebrow}
              </span>
              <h3>{product.title}</h3>
              <p>{product.description}</p>
            </div>
          </li>
        ))}
      </ul>
    </section>
  );
};
